import { PropsWithChildren, useContext } from 'react';

import {
  LegendFilterProvider,
  createLegendFilterContext,
} from 'business/providers/legend-filters';

interface IndicatorAnalyseLegendFilters extends Record<string, unknown> {
  allIndicators: boolean;
  selectedIndicators: string[];
}

const indicatorAnalyseDefaultLegendFilters: IndicatorAnalyseLegendFilters = {
  allIndicators: true,
  selectedIndicators: [],
};

const IndicatorAnalyseLegendFilterContext = createLegendFilterContext(
  indicatorAnalyseDefaultLegendFilters,
);

const IndicatorAnalyseLegendFilterProvider = ({
  children,
}: PropsWithChildren) => {
  return (
    <LegendFilterProvider
      defaultLegendFilters={indicatorAnalyseDefaultLegendFilters}
      legendFilterContext={IndicatorAnalyseLegendFilterContext}
    >
      {children}
    </LegendFilterProvider>
  );
};

const useLegendFilters = () => useContext(IndicatorAnalyseLegendFilterContext);

export {
  type IndicatorAnalyseLegendFilters,
  IndicatorAnalyseLegendFilterProvider,
  useLegendFilters,
};
